import { ClientProfile, VendorProfile } from "@/graphql/fragments.ts";
import { gql } from "@apollo/client";

export const USER_CONTEXT_QUERY = gql`
  query UserContext {
    isAuthenticated
    currentUser: me {
      id
      email
      username
      firstName
      lastName
      hasSubcontracting
      hasFtpUser
      timezone
      zendeskToken
      isMfaEnabled
      mfaEnabledOn
      mfaDisabledOn
      role
      securityLevel
      isStaff
      profilePictureUrl
      canBeAssignedTasks
      isSupervisor
      hotrockApiKey
      clientUserServiceAlertRules {
        edges {
          node {
            id
            action
            type
            maxPerToLowerBid
            serviceId
          }
        }
      }
      subcontractingUser {
        id
        office {
          id
          company {
            id
            profile {
              ...ClientProfile
              ...VendorProfile
            }
          }
        }
      }
      office {
        id
        isDeliveryDirectDownloadEnabled
        admins {
          id
          firstName
          lastName
        }
        excludedServicesWithDefaultVendors {
          id
        }
        isFinancialDashboardEnabled
        isFlashBidFeatureEnabled
        isCustomBidEnabled
        isCustomBidLiteEnabled
        isBidRequestAgreementDisabled
        isAiEnabled
        showTaskInfo
        hasCustomVendors
        bidRequestCurrency
        isUniversalInviteUserFeatureEnabled
        clientOfficeServiceAlertRules {
          edges {
            node {
              id
              action
              type
              maxPerToLowerBid
              preferredVendors {
                edges {
                  node {
                    id
                    profile {
                      ... on VendorProfile {
                        id
                        companyName
                      }
                    }
                  }
                }
              }
              serviceId
            }
          }
        }
        company {
          id
          type
          role
          isAlertManagementDashboardEnabled
          profile {
            ...ClientProfile
            ...VendorProfile
          }
        }
        name
        address
        address2
        address3
        city
        state
        zipcode
        timezone
        country {
          id
          officialName
        }
      }
    }
    announcements {
      id
      message
    }
  }
  ${ClientProfile}
  ${VendorProfile}
`;
